import { PaddedSurface } from "App/global-style";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { RecentDamages } from "Components/Form/RecentDamages";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductDetailsFormValues } from "./boatProductDetailsInterfaces";

interface Props {
  formProps: FormikProps<BoatProductDetailsFormValues>;
}

export const CommonFormElements = ({
  formProps,
}: Props): React.ReactElement => {
  return (
    <PaddedSurface>
      <RecentDamages
        formProps={formProps}
        productName={ProductBackendName.BOAT}
        withSurface
      />
    </PaddedSurface>
  );
};
